// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "." + {"589":"65615fc4","1412":"77872a84","3017":"77872a84"}[chunkId] + ".css";
};